import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import { ProtectedRoute } from './ProtectedRoute';
import Home from './pages/Home/Home';
import Chat from './pages/Chat/Chat';
import Login from './pages/Login/Login';
import Profile from './pages/Profile/Profile';
import ConfirmEmail from './pages/ConfirmEmail/ConfirmEmail';
import Study from './pages/Study/Study';
import About from './pages/About/About';
import Favorites from './pages/Favorites/Favorites';
import Shares from './pages/Shares/Shares';
import SampleChat from './pages/SampleChat/SampleChat';
import SampleDevotional from './pages/SampleDevotional/SampleDevotional';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { getReactPlugin } from './appInsights';
import DevotionalWithChat from './pages/DevotionalWithChat/DevotionalWithChat';

function App() {
  const reactPlugin = getReactPlugin();
  const version = process.env.REACT_APP_VERSION || 'dev';
  // Log version once during app initialization
  // eslint-disable-next-line no-console
  console.info('WalkItWithMe version:', version);

  const content = (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/confirm-email" element={<ConfirmEmail />} />
          <Route path="/about" element={<About />} />
          <Route path="/sample/chat/:slug" element={<SampleChat />} />
          <Route path="/sample/devotional/:slug" element={<SampleDevotional />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/shares/msg/:shortCode" element={<Shares />} />
          <Route
            path="/chat"
            element={
              <ProtectedRoute>
                <Chat />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/devotional-with-chat"
            element={
              <ProtectedRoute>
                <DevotionalWithChat />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/study"
            element={
              <ProtectedRoute>
                <Study />
              </ProtectedRoute>
            }
          />
          <Route
            path="/devotional"
            element={
              <ProtectedRoute>
                <DevotionalWithChat />
              </ProtectedRoute>
            }
          />
          <Route
            path="/favorites"
            element={
              <ProtectedRoute>
                <Favorites />
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );

  // Only wrap with AppInsightsContext if plugin is initialized
  if (reactPlugin) {
    return <AppInsightsContext.Provider value={reactPlugin}>{content}</AppInsightsContext.Provider>;
  }

  return content;
}

export default App;
